import { castArray, isArray } from "lodash-es";
import React, { useCallback, useMemo } from "react";
import { FormGroup, Label } from "reactstrap";

export const serializeInput =
  (Component) =>
  ({ delimiter = ",", input, ...rest }) => {
    const splitValue = useMemo(() => {
      const val = input.value;
      // TODO: This is indicative that we probably shouldn't be using serializeInput
      //  since the wrapped component seems to support multi-select
      if (Array.isArray(val)) {
        return val;
      }
      const splitVal = val ? val.toString().split(delimiter) : [];
      return castArray(splitVal);
    }, [input.value, delimiter]);

    const handleChange = useCallback(
      (arrVal) => {
        const joinedValue = isArray(arrVal) ? arrVal.join(delimiter) : arrVal;
        input.onChange(joinedValue);
      },
      [input, delimiter]
    );

    return <Component input={{ ...input, onChange: handleChange, value: splitValue }} {...rest} />;
  };

export const InputWrapper = ({ children, label, required, htmlFor, ...rest }) => (
  <FormGroup {...rest}>
    {label && (
      <Label htmlFor={htmlFor}>
        {label}
        {required && <span className="required-mark">*</span>}
      </Label>
    )}

    {children}
  </FormGroup>
);
